import Swiper from 'swiper/bundle';

if (!window.Swiper) {
  window.Swiper = Swiper;
}

const { feWp } = window;
const { applyFilters, addAction, doAction } = feWp.hooks;

// Define a filter to override SwiperExt
applyFilters('b3rg_tab_slider_library', Swiper);

const displayProgressBar = (swiperElm, swiperInstance, settings) => {
  const fragmentElm = swiperElm.querySelector('.swiper-fraction');
  const isPaginationEnabled = settings?.pagination?.enabled || false;
  const progressBarElm = swiperElm.querySelector(
    '.swiper-pagination-progressbar',
  );
  if (isPaginationEnabled && progressBarElm) {
    const totalSlide = swiperInstance.slides.length;
    const snapGrid = swiperInstance.snapGrid.length;
    const current = (swiperInstance.realIndex + 1) % totalSlide || totalSlide;
    fragmentElm.textContent = `${current}/${snapGrid}`;
  }
};

const removeSwiperClasses = (elm) => {
  elm.classList.remove(
    'swiper-android',
    'swiper-backface-hidden',
    'swiper-navigation-disabled',
    'swiper-pagination-disabled',
    'swiper-scrollbar-disabled',
  );
};

const sliderDestroy = (elm) => {
  removeSwiperClasses(elm);
};

const sliderOnChange = (elm, swiperInstance, settings) => {
  displayProgressBar(elm, swiperInstance, settings);
};

const sliderInit = (elm, swiperInstance, settings) => {
  elm.querySelector('[data-slide-index="0"]')?.classList.add('line-animate');
  displayProgressBar(elm, swiperInstance, settings);
};

const sliderBeforeInit = (elm, settings) => {
  elm.classList.remove('swiper--destroyed');
  const isPaginationEnabled = settings?.pagination?.enabled || false;
  if (isPaginationEnabled) {
    const paginationElm = elm.querySelector('.swiper-pagination');
    paginationElm?.classList.remove(
      'swiper-pagination-clickable',
      'swiper-pagination-bullets',
      'swiper-pagination-horizontal',
      'swiper-pagination-progressbar',
    );
  }
};
// NOSONAR
const tabSliderOnDeviceChange = (device) => {
  // Select all elements with the attribute 'data-swiper' except for specific classes
  const excludeSliders = applyFilters('b3rg_tab_slider_exclude', []);
  const excludeSliderclass = Array.from(excludeSliders)
    .map((sliderClass) => {
      return `:not(.${sliderClass})`;
    })
    .join('');
  const sliderSelector = `.e-tbs${excludeSliderclass}`;
  const tabSliders = document.querySelectorAll(sliderSelector);

  if (!tabSliders?.length > 0) return;

  Array.from(tabSliders).forEach((tabSlider) => {
    const tabNav = tabSlider.querySelector('.e-tbs__nav');
    const tabContent = tabSlider.querySelector('.e-tbs__content');

    let tabNavOptions = {};
    let tabContentOptions = {};

    const tabNavDataSwiper = tabNav.getAttribute('data-swiper') || {};
    const tabContentDataSwiper = tabContent.getAttribute('data-swiper') || {};

    if (tabNavDataSwiper) {
      tabNavOptions = JSON.parse(tabNavDataSwiper);
    }
    if (tabContentDataSwiper) {
      tabContentOptions = JSON.parse(tabContentDataSwiper);
    }

    const tabNavBreakpoint = tabNavOptions[device];
    const tabContentBreakpoint = tabContentOptions[device];

    if (!tabNavBreakpoint || !tabContentBreakpoint) return;

    let swiperTabNav = tabNav.swiper;
    let swiperTabContent = tabContent.swiper;
    /* eslint-disable @wordpress/no-unused-vars-before-return */
    const tabNavNextArrow = tabNav.querySelector('.swiper-button-next');
    const tabNavPrevArrow = tabNav.querySelector('.swiper-button-prev');
    /* eslint-enable @wordpress/no-unused-vars-before-return */

    const SwiperLibrary = applyFilters('b3rg_tab_slider_library', Swiper);

    // create navigation slider
    const enableNavSlider = (settings) => {
      if (settings?.navigation?.enabled) {
        tabNav.classList.remove('swiper-navigation-disabled');
      } else {
        tabNav.classList.add('swiper-navigation-disabled');
      }

      const defaultSwiperNavSettings = {
        ...settings,
        autoplay: false,
        navigation: false,
        on: {
          beforeInit() {
            doAction('b3rg_tab_slider_nav_before_init', settings, tabNav);
            sliderBeforeInit(tabNav, settings);
          },
          init(swiper) {
            doAction('b3rg_tab_slider_nav_init', settings, tabNav, swiper);
            sliderInit(tabNav, swiper, settings);
          },
          destroy() {
            doAction('b3rg_tab_slider_nav_destroy', settings, tabNav);
            sliderDestroy(tabNav);
          },
          slideChange(swiper) {
            doAction(
              'b3rg_tab_slider_nav_slideChange',
              settings,
              tabNav,
              swiper,
            );
            sliderOnChange(tabNav, swiper, settings);
          },
        },
      };

      const swiperNavSettings = applyFilters(
        'b3rg_tab_slider_nav_extend',
        defaultSwiperNavSettings,
        tabNav,
      );

      swiperTabNav = new SwiperLibrary(tabNav, swiperNavSettings);
    };

    // create tab slider
    const enableContentSlider = (settings) => {
      const defaultSwiperContentSettings = {
        ...settings,
        thumbs: {
          swiper: swiperTabNav,
        },
        on: {
          beforeInit() {
            doAction(
              'b3rg_tab_slider_content_before_init',
              settings,
              tabContent,
            );
            sliderBeforeInit(tabContent, settings);
          },
          init(swiper) {
            doAction(
              'b3rg_tab_slider_content_init',
              settings,
              tabContent,
              swiper,
            );
            sliderInit(tabContent, swiper, settings);
          },
          destroy() {
            doAction('b3rg_tab_slider_content_destroy', settings, tabContent);
            sliderDestroy(tabContent);
          },
          slideChange(swiper) {
            doAction(
              'b3rg_tab_slider_content_slideChange',
              settings,
              tabContent,
              swiper,
            );
            sliderOnChange(tabContent, swiper, settings);
          },
        },
      };
      const swiperContentSettings = applyFilters(
        'b3rg_tab_slider_content_extend',
        defaultSwiperContentSettings,
        tabContent,
      );

      swiperTabContent = new SwiperLibrary(tabContent, swiperContentSettings);
    };

    // destroy/init the nav slider considering the breakpoint destroy settings
    if (tabNavBreakpoint.destroy) {
      // nav slider destroyed
      if (swiperTabNav !== undefined) swiperTabNav.destroy();
      tabNav.classList.add('swiper--destroyed');
    } else {
      // nav slider enabled
      enableNavSlider(tabNavBreakpoint);
    }

    // destroy/init the content slider considering the breakpoint destroy settings
    if (tabContentBreakpoint.destroy) {
      // content slider destroyed
      if (swiperTabContent !== undefined) swiperTabContent.destroy();
      tabContent.classList.add('swiper--destroyed');
    } else {
      // content slider enabled
      enableContentSlider(tabContentBreakpoint);
    }

    // Returns if one of the instances is not initialized
    if (!swiperTabNav || !swiperTabContent) return;

    swiperTabNav?.on('navigationNext', function () {
      swiperTabContent.slideNext();
    });
    swiperTabNav?.on('navigationPrev', function () {
      swiperTabContent.slidePrev();
    });
    const NavSlidesCount = swiperTabNav.slides.length;

    swiperTabContent?.on('slideChange', function () {
      disableNavArrows();
    });

    function disableNavNextArrow() {
      const currentActive = parseInt(
        document
          .querySelector('.swiper-slide-thumb-active')
          .getAttribute('data-slide-index'),
      );

      if (NavSlidesCount <= currentActive + 1) {
        tabNavNextArrow.classList.add('disabled');
      } else {
        tabNavNextArrow.classList.remove('disabled');
      }
    }

    function disableNavPrevArrow() {
      const currentActive = parseInt(
        document
          .querySelector('.swiper-slide-thumb-active')
          .getAttribute('data-slide-index'),
      );

      if (currentActive === 0) {
        tabNavPrevArrow.classList.add('disabled');
      } else {
        tabNavPrevArrow.classList.remove('disabled');
      }
    }
    function disableNavArrows() {
      disableNavNextArrow();
      disableNavPrevArrow();
    }
    disableNavArrows();

    swiperTabNav?.on('slideChange', function () {
      disableNavArrows();
    });

    swiperTabNav?.on('click', function () {
      disableNavArrows();
    });

    tabNavNextArrow.addEventListener(
      'click',
      function () {
        disableNavArrows();
        const currentActive = parseInt(
          document
            .querySelector('.swiper-slide-thumb-active')
            .getAttribute('data-slide-index'),
        );

        const slidesCount = swiperTabNav.slides.length;
        if (currentActive + 1 < slidesCount) {
          swiperTabContent.slideNext();
        }
      },
      false,
    );

    tabNavPrevArrow.addEventListener(
      'click',
      function () {
        disableNavArrows();
        const currentActive = parseInt(
          document
            .querySelector('.swiper-slide-thumb-active')
            .getAttribute('data-slide-index'),
        );

        if (currentActive > 0) {
          swiperTabContent.slidePrev();
          swiperTabNav.slidePrev();
        }
      },
      false,
    );
  });
};

addAction(
  'b3rg_breakpoint_changed',
  'b3rg/tab-slider',
  tabSliderOnDeviceChange,
  10,
  1,
);

document.addEventListener('DOMContentLoaded', tabSliderOnDeviceChange);
